import {
	GetPlayerWithWithdrawRequest,
	GetPlayerWithWithdrawResponse,
} from '@/modules/manage-player/type'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getPlayerWithWithdraw } from '../../services'
import { PlayerQueryKeys } from '@/modules/manage-player/keys'

export default function useQueryGetPlayerWithWithdraws(
	payload: GetPlayerWithWithdrawRequest,
	props?: UseBaseQueryOptions<GetPlayerWithWithdrawResponse>,
) {
	return useQuery({
		queryKey: [PlayerQueryKeys.GetPlayerWithWithdraw, payload],
		queryFn: () => getPlayerWithWithdraw(payload),
		...props,
	})
}
